export const COURSE_DETAILS = 'COURSE_DETAILS';  // 当前查看的课程详情
export const COMMENT_LIST = 'COMMENT_LIST';  // 课程评论列表
